import React from 'react';
import { MotionReveal } from './MotionReveal';

type PageHeroProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle: string;
  children?: React.ReactNode;
  align?: 'left' | 'center';
  maxWidth?: string;
  scene?: 'cascades' | 'snoqualmie';
};

export function Highlight({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-verto-mint">
      {children}
    </span>
  );
}

export function PageHero({
  title,
  subtitle,
  children,
  align = 'center',
  maxWidth = 'max-w-4xl',
  scene = 'cascades',
}: PageHeroProps) {
  const isCenter = align === 'center';

  return (
    <section className="shoreline-page-hero relative overflow-hidden border-b border-verto-black/15 bg-verto-black py-20 text-verto-white md:py-28">
      <div className={`shoreline-page-hero__forest shoreline-page-hero__forest--${scene}`} aria-hidden="true" />
      <div className="page-wrap relative">
        <MotionReveal>
          <div className={`shoreline-page-hero__copy ${maxWidth} ${isCenter ? 'mx-auto text-center' : ''}`}>
            <h1 className="font-display text-5xl font-bold leading-[0.9] tracking-[-0.025em] text-verto-white md:text-7xl">
              {title}
            </h1>
            <p
              className={`mt-6 text-lg leading-relaxed text-verto-white/70 md:text-xl ${
                isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'
              }`}
            >
              {subtitle}
            </p>
            {children && <div className="mt-8">{children}</div>}
          </div>
        </MotionReveal>
      </div>
    </section>
  );
}
